import { render, staticRenderFns } from "./ResearchAudienceForm.vue?vue&type=template&id=49e1a6a4&"
import script from "./ResearchAudienceForm.vue?vue&type=script&lang=js&"
export * from "./ResearchAudienceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports